import { useQuery } from '@apollo/client'
import { GetHomeGenresDocument, GetHomeGenresQuery, RootCategory } from '~/__generated__/graphql'
import browserEnv from '~/libs/env/browserEnv'

function filteredAndSortedRootCategories(rootCategories: RootCategory[]): RootCategory[] {
  // "1: ジャンル", "114: 上映時間", "147 or 18: その他"をフィルタリング
  // "ジャンル"、"上映時間"、"その他"の順にソート
  const targetIds =
    browserEnv.NEXT_PUBLIC_ENV === 'production' ? ['1', '114', '147'] : ['1', '114', '18']

  console.log('targetIds:', targetIds)
  return rootCategories
    .filter((category) => targetIds.includes(category.id))
    .sort((a, b) => targetIds.indexOf(a.id) - targetIds.indexOf(b.id))
}

export function useGenreList(): RootCategory[] | 'loading' {
  const { data, error } = useQuery<GetHomeGenresQuery>(GetHomeGenresDocument)
  console.log('useGenreList data:', data)
  if (error) {
    throw error
  }
  if (data === undefined) {
    return 'loading'
  }

  const filteredCategories = filteredAndSortedRootCategories(data.rootCategories)
  return filteredCategories
}
